import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

import { CardDashboad } from '../components'
import { DataCoupons } from '../types'

const useStyles = makeStyles({
  title: {
    color: COLORS.BASE,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
})

interface propsCoupons {
  dataCoupons: DataCoupons
}

const CouponsCard: React.FC<propsCoupons> = ({ dataCoupons }) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" component="h2" className={classes.title}>
          Promos
        </Typography>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item xs={4}>
        <CardDashboad
          value={dataCoupons.used}
          description="Promos Usadas"
          value_previous={dataCoupons.used_previous}
          isPercent={false}
        />
      </Grid>
      <Grid item xs={4}>
        <CardDashboad
          value={dataCoupons.avg}
          description="Promos Promedio"
          value_previous={dataCoupons.avg_previous}
          isPercent
        />
      </Grid>
    </>
  )
}

export { CouponsCard }
